import { Award, Briefcase, CalendarDays, Camera, Sprout, type LucideIcon } from "lucide-react";
import { familyOfFormat, type FamilyKey } from "@/data/activation-families";
import type { ActivationFormat } from "@/hooks/use-engage-campaigns";
import type { BriefKind } from "@/data/brief-forms";

/** The icon of each stream, as in the sidebar. An activation shows the icon of its stream. */
export const FAMILY_ICONS: Record<FamilyKey, LucideIcon> = {
  product: Sprout,
  events: CalendarDays,
  content: Camera,
  affiliation: Award,
};

export function iconForFormat(format: ActivationFormat): LucideIcon {
  return format === "other" ? Briefcase : FAMILY_ICONS[familyOfFormat(format)];
}

/** The activation format a brief of this type turns into once communities are matched. */
const FORMAT_FOR_KIND: Record<BriefKind, ActivationFormat> = {
  seeding: "gifting",
  testing: "testing",
  panel: "panel",
  event: "sponsorship",
  community: "community-sponsorship",
  hosting: "private-experience",
  ugc: "ugc",
  branded: "branded-content",
  ambassador: "ambassador",
  affiliate: "affiliate",
};

export function iconForBriefKind(kind: BriefKind | null | undefined): LucideIcon {
  return kind ? iconForFormat(FORMAT_FOR_KIND[kind]) : Briefcase;
}
